import axios from "axios";
import serverMessage from "../server-message";

// Rev 4 read: a company's bundle assignment plus its materialised grants, straight from the
// canonical company-bundle endpoint (the legacy company-feature-group alias returned the same
// payload under the deprecated `featureGroupId` name). Rejects with the SERVER'S message where
// there is one: the Company Features panel renders this reason next to its Retry when the read
// leaves it with nothing to show, and "Request failed with status code 403" is not a reason.
export default function getCompanyBundle({ id }) {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/company-bundle/${id}`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(serverMessage(error))));
}
